import React from 'react'
import { IconType } from '../Icon'
import Button from '../Button'
import Time from './Time'
import SeekBar from './SeekBar'
import styles from './PlayerControls.module.scss'
import classnames from 'classnames'
import { PlayerControlProps } from './types'

import PlayButton from './PlayButton'

const _ID = 'player-controls'

const PlayerControls: React.FC<PlayerControlProps> = props => {

  if (typeof props.parentRef === 'undefined') return <div />

  const {
    playing = false,
    onStop = () => {},
    dataBdd = _ID,
    duration = 1, // Defaults to 1 to avoid division by zero
    currentTime = 0
  } = props

  const overlayClasses = classnames(styles['PlayerControls-overlay'], {
    [styles['--show']]: !playing
  })

  const getProgress = () => duration ? currentTime / duration : 0

  return <div
    className={styles['PlayerControls-hotZone']}
    data-bdd={dataBdd}
  >
    <div className={overlayClasses} data-bdd={`${dataBdd}-overlay`} >
      <div className={styles['PlayerControls-container']} data-bdd={`${dataBdd}-grid`} >

        <PlayButton
          playerRef={props.parentRef}
          onPlay={props.onPlay}
          pendingPlaybackRequest={props.pendingPlaybackRequest}
          playing={playing}
        />

        <Time
          currentTime={currentTime}
          duration={duration}
        />

        <SeekBar
          progress={getProgress()}
          subscriber={props.subscriber}
        />

        <Button
          onClick={onStop}
          color={IconType.colour.secondary}
          dataBdd={`${dataBdd}-stop-button`}
        >
          End video
        </Button>

      </div>
    </div>
  </div>

}

export default PlayerControls
